// extracted by mini-css-extract-plugin
export var attachmentContainer = "_i0-0";
export var fileList = "_i0-2";
export var removeFileButton = "_i0-1";